// extracted by mini-css-extract-plugin
export default {"actionBtn":"Update_actionBtn__r8YnG","confirm":"Update_confirm__moNxt","reject":"Update_reject__+FRCp"};